import React from "react";
import "../stb_styles.css";

class Notfound extends React.Component{
    componentDidMount(){
        if(!window.location.pathname.toString().includes("/404")){
            this.props.history.push("/404");
        }
    }
    render(){
        return <h1>Page Not Found</h1>;
    }
}
export default Notfound;
